<template>
    <footer class="footer container_wrap">
        <div class="container">
            <div class="text">We've built solutions for...</div>
            <div class="logos">
                <a href="https://korsar.org.ua/" class="logo-item" target="_blank" rel="noreferrer">
                    <img src="img/logos/korsar.svg" alt="Korsar" title="Korsar" loading="lazy">
                </a>
                <a href="https://bagrayev.com/" class="logo-item mb" target="_blank" rel="noreferrer">
                    <img src="img/logos/mb.svg" alt="Mykola Bagrayev" title="Mykola Bagrayev" loading="lazy">
                </a>
                <a href="https://desmi.group/" class="logo-item alaska" target="_blank" rel="noreferrer">
                    <img src="img/logos/alaska.svg" alt="Desmi Group" title="Desmi Group" loading="lazy">
                </a>
            </div>
        </div>
    </footer>
</template>

<script>

import { TimelineMax } from 'gsap';

export default {
  name: 'FooterComponent',
  mounted: function () {
    var tl = new TimelineMax();
    tl
      .to(('.footer .text'), 0.3, { opacity: 1, x: 0 }, '+=0.75')
      .staggerTo(('.logo-item'), 0.3, { opacity: 1, y: 0 }, 0.25);
  }
};
</script>

<style lang="scss">

</style>
